/*eslint-disable import/default*/
import "babel-polyfill";
import React from "react";
import ReactDOM from "react-dom";
import {connect, Provider} from "react-redux";
import {Route, IndexRoute, Router, hashHistory} from "react-router";
import PolicyPage from "./components/PolicyPage";
import PolicyPage1 from "./components/PolicyPagenew";
import MyPolicypage from "./components/myPolicy";
import PolicyAdmin from "./components/PolicyAdmin";
import injectTapEventPlugin from "react-tap-event-plugin";
import MuiThemeProvider from "material-ui/styles/MuiThemeProvider";
import Test from "./components/Test";
import toastr from "toastr";
import QCap from './feature/qcap/QCap';
import QCapHome from './feature/qcap/QCapHome';
import configureStore from "./store/configureStore";
import App from "./containers/App";
import Home from "./components/Home/Home";
import LoginPage from "./containers/LoginPage";
import InvalidEmail from "./containers/InvalidEmailId";
import Forgot from "./react/mainComponents/Forgot";
import MainPage from "./containers/MainPage";
import AttendanceHome from "./feature/attendance/AttendanceHome";
import * as authActions from "./redux/actions/Authentication/authActions";
import MyAttendance from "./feature/attendance/MyAttendance/MyAttendance";
import TeamAttendance from "./feature/attendance/TeamAttendance/TeamAttendance";
import MyAttendanceRegularisation from "./feature/attendance/MyAttendance/MyAttendanceRegularisaton";
import MyTeamRegularisation from "./feature/attendance/TeamAttendance/MyTeamRegularisation";
import MyTeamRegularisationReport from "./feature/attendance/TeamAttendance/MyTeamRegularisationReport";
import AppAccessHome from "./feature/appAccess/AppAccessHome";
import MyApplicationsHome from "./feature/appAccess/MyApplications/MyApplicationHome";
import TeamApplicationsHome from "./feature/appAccess/myTeamApplications/myTeamApplicationsHome";
import VhApplicationsHome from "./feature/appAccess/myVhApplications/myVhApplicationsHome";
import OwnerApplicationHomes from "./feature/appAccess/myOwnerApplications/myOwnerApplicationsHome";
import LeaveHome from "./feature/leave/LeaveHome";
import LeaveApply from "./feature/leave/LeaveApply/LeaveApply";
import LeaveTeam from "./feature/leave/LeaveTeam/LeaveTeam";
import LeaveHistory from "./feature/leave/LeaveHistory/LeaveHistory";
import LeaveTeamHistory from "./feature/leave/LeaveTeamHistory";
import LeaveTeamWeekly from "./feature/leave/LeaveTeamWeekly";
import {loadState, saveState, refreshState} from "./loadState";
import ProfilePage from "./components/ProfilePage/ProfilePage";
import Reporting from "./components/Reporting";
import AdminHome from "./feature/hradmin/AdminHome";
import AbscondHome from "./feature/hradmin/abscond/AbscondHome"
import AdministratorHome from "./feature/admin/AdminHome";
import AdministratorExits from "./feature/admin/Exit/AdminExitHome";
import AdministratorOnBoarding from "./feature/admin/OnBoarding/OnBoarding";
import AdministratorOnBoardingExpected from "./feature/admin/OnBoardingExpected/OnBoardingExpected";
import FinanceHome from "./feature/finance/FinanceHome";
import FinanceExits from "./feature/finance/exit/FinanceExitHome";
import FinanceOnBoarding from "./feature/finance/OnBoarding/OnBoarding";
import FinanceOnBoardingExpected from "./feature/finance/OnBoardingExpected/OnBoardingExpected";
import PeopleSearchHome from "./feature/hradmin/PeopleSearch/PeopleSearchHome";
import ItHome from "./feature/it/ItHome";
import ItExits from "./feature/it/Exit/ItExitHome";
import ItOnBoarding from "./feature/it/OnBoarding/OnBoarding";
import ItOnBoardingExpected from "./feature/it/OnBoardingExpected/OnBoardingExpected";
import ExitHome from "./feature/hradmin/Exit/ExitHome";
import Auth from "./redux/actions/Authentication/auth.class";
import {storeEmp as stores} from "./redux/actions/empActions";
import {beginAjaxCall} from "./redux/actions/ajaxStatusActions";
import MyProfile from "./feature/myProfile/MyProfileHome";
import EmployeeSS from "./feature/myProfile/EmployeeSS/EmployeeSS";
import VerticalSS from "./feature/myProfile/VerticalSS/ManagerSS";
import ManagerSS from "./feature/myProfile/ManagerSS/ManagerSS";
import ExitSS from "./feature/myProfile/Exit/EmployeeExit";
import MyExit from "./feature/myProfile/MyExit/MyExitHome";
import ExitFnF from "./feature/hradmin/ExitFinal/ExitHome";
import NewJoiner from "./feature/hradmin/onboarding/NewJoiner";
import ExpectedJoiner from "./feature/hradmin/onboarding/ExpectedJoiner";
import MyTeamRoster from "./feature/attendance/AttendanceRoster/AttendanceRoster";
import RecruiterHome from "./feature/onboarding/RecruiterHome";
import NewJoinerHome from "./feature/onboarding/containers/NewJoiner";
import AddNewJoiner from "./feature/onboarding/containers/RecruiterAdd";
import EditNewJoiner from "./feature/onboarding/containers/RecruiterAddEdit";
import HrbpHome from "./feature/hrbp/HrbpHome";
import HrbpExits from "./feature/hrbp/Exits/EmployeeExit";
import TeamExit from "./feature/myProfile/MyTeamExit/MyTeamExitHome";
import AttendanceUpload from "./feature/attendance/AttendanceUpload/AttendanceUpload";
import NewJoinerEdit from "./feature/hradmin/onboarding/components/AdminEdit";
import AdminUpload from "./feature/hradmin/upload/UploadHome";
import AnnouncementsCreate from "./feature/announcements/AnnouncementsCreateNew";
import Announcements from "./feature/announcements/AnnouncementsHome";
import Announcement from "./feature/announcements/Announcement";
import AnnoucementsHome from "./feature/announcements/AnnouncementsHomePage";
import LeaveBalanceHome from "./feature/leave/LeaveBalance/LeaveBalanceHome";
import DogFoodingHome from "./feature/announcements/DogFoodingHome";
import ChatterHome from './feature/announcements/ChatterHome';
import FeedbackHome from './feature/feedback/feedbackHome';
import QCapTeamHome from './feature/qcap/QCapTeamHome';
import DownloadHome from './feature/hradmin/download/DownloadHome';
import QCapUpload from './feature/hrbp/QCapUpload';
import ReferralHome from "./components/Referral/ReferralHome";
import JobReferral from "./components/Referral/JobReferral";
import ReferralAdmin from "./components/Referral/ReferralAdmin";
import MyReferral from "./components/Referral/MyReferral";
import ReferralDashboard from "./components/Referral/ReferralDashboard";
import CtcSplitHome from "./feature/hradmin/ctcSplit/CtcSplitHome";



//react imports
//router imports
//store imports
//actions imports
//import HomePage from './components/home/HomePage';
//css styles


//generally pass initial state as default parameters in each of the reducers..., pass initial state in configure store
//if server sends some data or fields that need to filled up before app starts off.
const persistedState = loadState();


let store = configureStore();
let flag = localStorage.getItem('loggedInHRMS');

if (flag == "true") {
  store.dispatch(beginAjaxCall());
  if (persistedState != null && persistedState != undefined) {
    store.dispatch(beginAjaxCall());
    store.dispatch(stores(persistedState[0]));
  }
  Auth.loggedIn = true;
  Auth.EmpId = store.getState().emp[0].empno;
  store.dispatch(authActions.loginSuccess(Auth))
}
store.subscribe(()=> {
  saveState(store.getState().emp);
});
store.subscribe(()=> {
  refreshState(store.getState().auth);
});


class ReactRoute extends React.Component {
  constructor() {
    super();
    this.state = {open: 0, showComponent: PeopleSearchHome, showPath: 'peopleSearch'};
    this.auth = this.auth.bind(this);
  }

  auth(nextState, replace) {
    if (!store.getState().auth[0].loggedIn) {
      toastr.info("Kindly Login !!");
      replace({pathname: '/login', state: {nextPathname: nextState.location.pathname}});
    }
  }
  requireAuth(nextState, replace) {

    if (!store.getState().auth[0].loggedIn) {
      replace({pathname: '/login', state: {nextPathname: nextState.location.pathname}});
    }
  }

  isRecruiter(nextState, replace) {
    if (!store.getState().emp[0].recruiter) {
      toastr.error("You are not Authorized!! Please contact the administrator");
      replace({pathname: '/1/home', state: {nextPathname: nextState.location.pathname}});
    }
  }
  isAdmin(nextState, replace) {
    if (!store.getState().emp[0].hr) {
      toastr.error("You are not Authorized!! Please contact the administrator");
      replace({pathname: '/1/home', state: {nextPathname: nextState.location.pathname}});
    }
  }

  isHrbp(nextState, replace) {

    if (!store.getState().emp[0].hrbp) {
      toastr.error("You are not Authorized!! Please contact the administrator");
      replace({pathname: '/1/home', state: {nextPathname: nextState.location.pathname}});
    }
  }
  isIT(nextState, replace) {

    if (!store.getState().emp[0].it) {
      toastr.error("You are not Authorized!! Please contact the administrator");
      replace({pathname: '/1/home', state: {nextPathname: nextState.location.pathname}});
    }
  }
  isFinance(nextState, replace) {

    if (!store.getState().emp[0].finance) {
      toastr.error("You are not Authorized!! Please contact the administrator");
      replace({pathname: '/1/home', state: {nextPathname: nextState.location.pathname}});
    }
  }
  isFacilities(nextState, replace) {

    if (!store.getState().emp[0].admin) {
      toastr.error("You are not Authorized!! Please contact the administrator");
      replace({pathname: '/1/home', state: {nextPathname: nextState.location.pathname}});
    }
  }

  isVertical(nextState, replace) {

    if (!store.getState().emp[0].vertical) {
      toastr.error("You are not Authorized!! Please contact the administrator");
      replace({pathname: '/1/home', state: {nextPathname: nextState.location.pathname}});
    }
  }

  isManager(nextState, replace) {

    if (!store.getState().emp[0].manager) {
      toastr.error("You are not Authorized!! Please contact the administrator");
      replace({pathname: '/1/home', state: {nextPathname: nextState.location.pathname}});
    }
  }

  isVerticalOrManager(nextState, replace) {
      let flag = 0;
      if (store.getState().emp[0].vertical || store.getState().emp[0].manager){
        flag = 1;
      }

      if (!flag) {
        toastr.error("You are not Authorized!! Please contact the administrator");
        replace({pathname: '/1/home', state: {nextPathname: nextState.location.pathname}});
      }
    }

  showPeopleSearchTab(nextState, replace) {

      if (!store.getState().emp[0].peopleSearch) {
          toastr.error("You are not Authorized!! Please contact the administrator");
          replace({pathname: '/1/home', state: {nextPathname: nextState.location.pathname}});
      }
  }

    showExitsTab(nextState, replace) {

        if (!store.getState().emp[0].exits) {
            toastr.error("You are not Authorized!! Please contact the administrator");
            replace({pathname: '/1/home', state: {nextPathname: nextState.location.pathname}});
        }
    }

    showOnBoardingTab(nextState, replace) {

        if (!store.getState().emp[0].onBoarding) {
            toastr.error("You are not Authorized!! Please contact the administrator");
            replace({pathname: '/1/home', state: {nextPathname: nextState.location.pathname}});
        }
    }

    showExitsFnFTab(nextState, replace) {

        if (!store.getState().emp[0].exitsFnF) {
            toastr.error("You are not Authorized!! Please contact the administrator");
            replace({pathname: '/1/home', state: {nextPathname: nextState.location.pathname}});
        }
    }

    showOnBoardingExpectedTab(nextState, replace) {

        if (!store.getState().emp[0].onBoardingExpected) {
            toastr.error("You are not Authorized!! Please contact the administrator");
            replace({pathname: '/1/home', state: {nextPathname: nextState.location.pathname}});
        }
    }

    showLeaveTab(nextState, replace) {

        if (!store.getState().emp[0].leave) {
            toastr.error("You are not Authorized!! Please contact the administrator");
            replace({pathname: '/1/home', state: {nextPathname: nextState.location.pathname}});
        }
    }

    showUploadTab(nextState, replace) {

        if (!store.getState().emp[0].upload) {
            toastr.error("You are not Authorized!! Please contact the administrator");
            replace({pathname: '/1/home', state: {nextPathname: nextState.location.pathname}});
        }
    }

    showDownloadTab(nextState, replace) {

        if (!store.getState().emp[0].download) {
            toastr.error("You are not Authorized!! Please contact the administrator");
            replace({pathname: '/1/home', state: {nextPathname: nextState.location.pathname}});
        }
    }

    showCtcSplitTab(nextState, replace) {

        if (!store.getState().emp[0].ctcSplit ) {
            toastr.error("You are not Authorized!! Please contact the administrator");
            replace({pathname: '/1/home', state: {nextPathname: nextState.location.pathname}});
        }
    }

    showAbscondDetails(nextState, replace){
      if (!store.getState().emp[0].abscond ) {
        toastr.error("You are not Authorized!! Please contact the administrator");
        replace({pathname: '/1/home', state: {nextPathname: nextState.location.pathname}});
    }
    }
    showHRAdminTab(nextState, replace) {
      let empRoles = store.getState().emp[0];
      if(empRoles.hr) {
          if (empRoles.peopleSearch || empRoles.exits || empRoles.exitsFnF || empRoles.onBoarding ||
              empRoles.onBoardingExpected || empRoles.leave || empRoles.upload || empRoles.download || empRoles.ctcSplit || empRoles.abscond) {
              return true;
          } else {
              return false;
          }
      } else {
          return false;
      }
    }

    componentWillMount() {
        let empRoles = store.getState().emp[0];
        if(empRoles.peopleSearch === true) {
            this.setState({ showComponent: PeopleSearchHome, showPath: 'peopleSearch'}, function() { });
            return;
        } else if(empRoles.exits === true) {
            this.setState({ showComponent:ExitHome, showPath: 'exit' }, function() { });
            return;
        } else if(empRoles.exitsFnF === true) {
            this.setState({ showComponent: ExitFnF, showPath:'exitFnF' }, function() { });
            this.setState({showComponent: ExitFnF, showPath:'exitFnF'})
        } else if(empRoles.onBoarding === true) {
            this.setState({ showComponent: NewJoiner, showPath:'onBoarding' }, function() { });
            return;
        } else if(empRoles.onBoardingExpected === true) {
            this.setState({ showComponent: ExpectedJoiner, showPath:'onBoardingExpected' }, function() { });
            return;
        } else if(empRoles.leave === true) {
            this.setState({ showComponent: LeaveBalanceHome, showPath:'leave' }, function() { });
            return;
        } else if(empRoles.upload === true) {
            this.setState({ showComponent: AdminUpload, showPath:'upload' }, function() { });
            return;
        } else if(empRoles.download === true) {
            this.setState({ showComponent: DownloadHome, showPath:'download' }, function() { });
            return;
        } else if(empRoles.ctcSplit === true) {
            this.setState({ showComponent: CtcSplitHome, showPath:'CtcSplitHome' }, function() { });
            return;
        }else if(empRoles.abscond === true) {
          this.setState({ showComponent: AbscondHome, showPath:'AbscondHome' }, function() { });
          return;
      }
    }


  showFeedback(nextState, replace) {
    let currentDate = new Date();
    console.log(currentDate);
    let month = currentDate.getMonth();
    currentDate.setDate(currentDate.getDate() + 3)
    //check for feedback only on the last 3 days of the month
    if(currentDate.getMonth() !== month) {
      let xhr = new XMLHttpRequest();
      xhr.open("GET", process.env.REQ_URL + '/feedback/getUserFeedback', false);
      xhr.withCredentials = true;
      xhr.send(null);
      if (xhr.status === 200) {
        console.log(xhr.responseText);
        replace({pathname: '/1/home', state: {nextPathname: nextState.location.pathname}});
      }
      else {
        console.log(xhr.responseText);
        replace({pathname: '/1/feedback', state: {nextPathname: nextState.location.pathname}});
      }
    }
    else
      replace({pathname: '/1/home', state: {nextPathname: nextState.location.pathname}});
  }

  render() {
    return (
      <Router history={hashHistory}>
        <Route path="/" component={App}>
          <Route path="/login" component={LoginPage}/>
          <Route path="/invalidEmail" component={InvalidEmail}/>
          <Route path="/forgot" component={Forgot}/>
          <Route path="/test" component={Test}/>

          <Route path="/1" component={MainPage} onEnter={this.requireAuth}>
            <IndexRoute onEnter={this.showFeedback}/>
            <Route path="profile/:id" component={ProfilePage}/>
           <Route path="policy"
                   getComponent={(location, callback) => {
                     // Do async things here
                     callback(null, PolicyPage);
                   }}
            />
            <Route path="policy1" component={PolicyPage1}>
              <IndexRoute component={MyPolicypage}/>
              <Route path="myPolicy" component={MyPolicypage}/>
              <Route path="admin" component={PolicyAdmin} onEnter={this.isAdmin}/>
            </Route>

            <Route path="home" component={Home} onEnter={this.requireAuth}/>
            <Route path="myReporting" component={Reporting}/>
            <Route path="myProfile" component={MyProfile}>
              <IndexRoute component={EmployeeSS}/>
              <Route path="home" component={EmployeeSS}/>
              <Route path="myExit" component={MyExit} />
              <Route path="teamExits" component={TeamExit} onEnter={this.isManager}/>
              <Route path="vertical" component={VerticalSS} onEnter={this.isVertical}/>
              <Route path="verticalExits" component={ExitSS} onEnter={this.isVertical} />
              <Route path="team" component={ManagerSS} onEnter={this.isManager}/>
              <Route path="teamAbsconds" component={AbscondHome} onEnter={this.isManager}/>
            </Route>

            <Route path="announcements" component={Announcements}>
              <IndexRoute component={AnnoucementsHome}/>
              <Route path="announcementsHome" component={AnnoucementsHome}/>
              <Route path="announcement/:id" component={Announcement}/>
              <Route path="quikrInspectr" component={DogFoodingHome}/>
              <Route path="chatter" component={ChatterHome}/>
              <Route path="createNew" component={AnnouncementsCreate}/>
            </Route>


            <Route path="feedback" component={FeedbackHome}>
            </Route>


              {this.showHRAdminTab()?<Route path="admin" component={AdminHome} onEnter={this.isAdmin} >
              <IndexRoute path={this.state.showPath} component={this.state.showComponent} onEnter={this.isAdmin} />
              <Route path="peopleSearch" component={PeopleSearchHome} onEnter={this.showPeopleSearchTab} />
              <Route path="exit" component={ExitHome} onEnter={this.showExitsTab}/>
              <Route path="exitFnF" component={ExitFnF} onEnter={this.showExitsFnFTab}/>
              <Route path="onBoarding" component={NewJoiner} onEnter={this.showOnBoardingTab}/>
              <Route path="onBoardingExpected" component={ExpectedJoiner} onEnter={this.showOnBoardingExpectedTab}/>
              <Route path="onBoardingEdit/:id" component={NewJoinerEdit} onEnter={this.isAdmin}/>
              <Route path="leave" component={LeaveBalanceHome} onEnter={this.showLeaveTab}/>
              <Route path="upload" component={AdminUpload} onEnter={this.showUploadTab}/>
              <Route path="download" component={DownloadHome} onEnter={this.showDownloadTab}/>
              <Route path="qcapUpload" component={QCapUpload} onEnter={this.isAdmin()}/>
              <Route path="ctcSplit" component={CtcSplitHome} onEnter={this.showCtcSplitTab}/>
              <Route path="abscond" component={AbscondHome} onEnter={this.showAbscondDetails}/>
          </Route>:null}

              <Route path="it" component={ItHome}>
              <IndexRoute component={ItExits} />
              <Route path="exits" component={ItExits} />
              <Route path="onBoarding" component={ItOnBoarding} />
              <Route path="onBoardingExpected" component={ItOnBoardingExpected} />
            </Route>

            <Route path="hrbp" component={HrbpHome} onEnter={this.isHrbp}>
              <IndexRoute component={HrbpExits} onEnter={this.isHrbp}/>
              <Route path="qcapUpload" component={QCapUpload} onEnter={this.isHrbp}/>
              <Route path="exits" component={HrbpExits} onEnter={this.isHrbp}/>
              <Route path="leave" component={LeaveBalanceHome} onEnter={this.isHrbp}/>
              <Route path="qcap" component={QCapTeamHome} onEnter={this.isHrbp}/>
              <Route path="qcapUpload" component={QCapUpload} onEnter={this.isHrbp}/>
            </Route>

            <Route path="administrator" component={AdministratorHome} onEnter={this.isFacilities}>
              <IndexRoute component={AdministratorExits} onEnter={this.isFacilities}/>
              <Route path="exits" component={AdministratorExits} onEnter={this.isFacilities}/>
              <Route path="onBoarding" component={AdministratorOnBoarding} onEnter={this.isFacilities}/>
              <Route path="onBoardingExpected" component={AdministratorOnBoardingExpected} onEnter={this.isFacilities}/>
            </Route>

            <Route path="finance" component={FinanceHome} onEnter={this.isFinance}>
              <IndexRoute component={FinanceExits} onEnter={this.isFinance}/>
              <Route path="exits" component={FinanceExits} onEnter={this.isFinance}/>
              <Route path="onBoarding" component={FinanceOnBoarding} onEnter={this.isFinance}/>
              <Route path="onBoardingExpected" component={FinanceOnBoardingExpected} onEnter={this.isFinance}/>
              <Route path="leave" component={LeaveBalanceHome} onEnter={this.isFinance}/>
            </Route>

            <Route path="recruiter" component={RecruiterHome} onEnter={this.isRecruiter}>
              <IndexRoute component={NewJoinerHome} onEnter={this.isRecruiter}/>
              <Route path="onBoarding" component={NewJoinerHome} onEnter={this.isRecruiter}>
                <IndexRoute component={NewJoinerHome}/>
              </Route>
              <Route path="add" component={AddNewJoiner} onEnter={this.isRecruiter}/>
              <Route path="edit/:id" component={EditNewJoiner} onEnter={this.isRecruiter}/>
            </Route>

            <Route path="referral" component={ReferralHome}>
              <IndexRoute component={JobReferral}/>
                <Route path="jobReferral" component={JobReferral}/>
                <Route path="myReferral" component={MyReferral}/>
                <Route path="referralAdmin" component={ReferralAdmin} onEnter={this.isAdmin}/>
                <Route path="referralDashboard" component={ReferralDashboard} onEnter={this.isAdmin}/>
            </Route>

            <Route path="qcap" component ={QCap}>
                   <IndexRoute component={QCapHome} />
                   <Route path ="home" component={QCapHome}/>
                   <Route path ="team" component={QCapTeamHome}/>
             </Route>


            <Route path="attendance" component={AttendanceHome}>
              <IndexRoute component={MyAttendance}/>
              <Route path="myAttendance" component={MyAttendance}/>
              <Route path="myAttendanceRegularisation" component={MyAttendanceRegularisation}/>
              <Route path="team" component={TeamAttendance} onEnter={this.isManager}/>
              <Route path="teamRegularisation" component={MyTeamRegularisation} onEnter={this.isManager}/>
              <Route path="teamRegularisationReport" component={MyTeamRegularisationReport} onEnter={(this.isVerticalOrManager)}/>
              <Route path="teamRoster" component={MyTeamRoster} onEnter={this.isManager}/>
              <Route path="attendanceUpload" component={AttendanceUpload} />
            </Route>

            <Route path="leave" component={LeaveHome}>
              <IndexRoute component={LeaveApply}/>
              <Route path="apply" component={LeaveApply}/>
              <Route path="history" component={LeaveHistory}/>
              <Route path="team" component={LeaveTeam}  onEnter={this.isManager} />
              <Route path="teamhistory" component={LeaveTeamHistory}  onEnter={this.isManager}/>
              <Route path="teamdetails" component={LeaveTeamWeekly}  onEnter={this.isManager}/>
            </Route>

            <Route path="applicationAccess" component={AppAccessHome}>
              <IndexRoute component={MyApplicationsHome}/>
              <Route path="myApplications" component={MyApplicationsHome}/>
              <Route path="myTeamApplications" component={TeamApplicationsHome}/>
              <Route path="vhTeamApplications" component={VhApplicationsHome}/>
              <Route path="myOwnerApplications" component={OwnerApplicationHomes}/>
            </Route>
          </Route>
        </Route>
      </Router>
    );
  }


}
injectTapEventPlugin();
ReactDOM.render(<Provider store={store}>
    <MuiThemeProvider   >
      <ReactRoute />
    </MuiThemeProvider>
  </Provider>, document.getElementById('app')
);


export default connect(ReactRoute);

//Provider is used to connect the react components to the redux store
//!store.getState().auth[0].loggedIn
/*
 if(!store.getState().auth[0].loggedIn)
 {

 if (window.location.href.indexOf("auth_code") != -1) {
 sessionStorage.setItem('authCode', window.location.search.split('=')[1]);
 store.dispatch(authActions.login({'id': window.location.search.split('=')[1]}));
 setTimeout(()=>{ReactDOM.render(<Provider store={store}>
 <MuiThemeProvider   >
 <ReactRoute />
 </MuiThemeProvider>
 </Provider>, document.getElementById('app')
 );},1500);
 }
 else {
 {

 axios.get('https://accounts.quikr.com/identity/v1/auth?clientId=hrms&redirectUri=https://hrms.quikrcorp.com&responseType=code&scope=openid&auth=Basic fOnLeHwsmThjrzmUeJEFiA==').
 then((response)=>{

 window.location=response.request.responseURL;
 }).catch((error)=>{
 console.log(error);
 console.log('yeah');
 });}

 }

 }
 else {

 ReactDOM.render(<Provider store={store}>
 <MuiThemeProvider   >
 <ReactRoute />
 </MuiThemeProvider>
 </Provider>, document.getElementById('app')
 );
 }
 */

/*
 if (window.location.href.indexOf("auth_code") != -1) {
 sessionStorage.setItem('authCode', window.location.search.split('=')[1]);
 }
 else {
 https://accounts.quikr.com/identity/v1/auth?clientId=hrms&redirectUri=https://hrms.quikrcorp.com&responseType=code&scope=openid&auth=Basic fOnLeHwsmThjrzmUeJEFiA==
 {http://accounts.quikr.com:13000/identity/v1/auth?clientId=hrms&redirectUri=http://192.168.101.88:3333&responseType=code&scope=openid&auth=Basic MkpWp9n1QvWIkunx2YwfuQ==
 axios.get('http://accounts.quikr.com:13000/identity/v1/auth?clientId=hrms&redirectUri=http://192.168.101.88:3333&responseType=code&scope=openid&auth=Basic MkpWp9n1QvWIkunx2YwfuQ==').then((response)=>{
 console.log("HEYHEYHEYHEY");
 console.log("does this work");

 console.log(response);
 console.log(response.request.responseURL);
 window.location=response.request.responseURL;
 }).catch((error)=>{
 console.log(error);
 console.log('yeah');
 });}

 }
 */



/** WEBPACK FOOTER **
 ** ./src/index.js
 **/